import TextHighlightMarkPlugin from './TextHighlightMarkPlugin';

export default [TextHighlightMarkPlugin];
